import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AboutAuth from "../../components/UI/AboutAuth";

import { useStore } from "../../hook-store/store";

// import { kuraStorageLink } from '../../App';

// import { marks } from "../../utils/marks";
import './TextVoiceAssistant.css';

const TextVoiceAssistantAbout = (props) => {

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // },[]);

  return (
    <Fragment>
      <div className="textVoiceAssistantAbout">
        <p>
          In Text Voice Assistant,
          {' '}
          {t("textVoiceAssistant10", "user can ask questions to AI assistant by using text input or voice input.")}
        </p>
        <br/>

        <p>
          {t("textVoiceAssistant11", "User can ask any questions. But it is diffucult to answer latest topics for this assistant, because the data that this assistant use do not include latest topics.")}
        </p>

        {/* <br/> */}
        {!isAuth && (
          <AboutAuth />
        )}
      </div>
    </Fragment>
  );
};
export default TextVoiceAssistantAbout;
